module.exports = __webpack_public_path__ + "img/students.55d248c2.svg";